module.exports = __webpack_public_path__ + "img/SysCom_wifi-1536x864.3783fb41.jpg";